module.exports = __webpack_public_path__ + "img/huawei.e5a908de.png";